export default __webpack_public_path__ + "static/media/528hz-dna-repair.d733e693.ogg";